import { Button, Skeleton, type SkeletonProps } from "@mui/material";
import { CORNER_EXTRA_LARGE } from "./icon/Corners";

export const ButtonSkeleton = ({ fullWidth, ...props }: SkeletonProps & { fullWidth?: boolean }) => (
  <Skeleton
    variant="rectangular"
    width={fullWidth ? "100%" : undefined}
    sx={{ borderRadius: CORNER_EXTRA_LARGE }}
    {...props}
  >
    <Button>.</Button>
  </Skeleton>
);
